module.exports = __webpack_public_path__ + "static/media/vip_bg_0.04d461ff.png";